export const FORUM_WATCHLIST = 'forum-watchlist'
